<template>
  <ag-card-container
    :search.sync="search"
    title="Liste des causes de rebut"
    fluid
    no-content-padding
  >
    <template #left>
      <v-btn
        color="success"
        fab
        x-small
        :loading="loadingExport"
        @click="exportExcel"
      >
        <v-icon>file_download</v-icon>
      </v-btn>
    </template>

    <rejection-cause-list
      :value="rejectionCauseList"
      :selected.sync="selectedRejectionCauseList"
      :loading="loadingData"
      :search="search"
    >
      <template #footer>
        <v-btn
          color="accent"
          outlined
          small
          append
          to="restore"
        >
          éléments supprimés
        </v-btn>
      </template>
    </rejection-cause-list>

    <ag-float-button-container>
      <ag-confirm-dialog
        v-if="selectedRejectionCauseList.length"
        title="Confirmation"
        :message="removeMessage"
        cancel-label="Annuler"
        confirm-label="Supprimer"
        validation-btn-color="error"
        @confirm="removeSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRemove"
            color="error"
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>delete</v-icon>
            <v-chip
              x-small
              class="px-1 float-chip font-weight-black"
              color="white"
              text-color="error"
              v-text="selectedRejectionCauseList.length"
            />
          </v-btn>
        </template>
      </ag-confirm-dialog>
      <v-btn
        to="create"
        append
        color="accent"
        fab
      >
        <v-icon>add</v-icon>
      </v-btn>
    </ag-float-button-container>

    <!-- RouterView for modals -->
    <router-view />
  </ag-card-container>
</template>

<script>
import AgCardContainer from 'src/components/common/AgCardContainer'
import AgFloatButtonContainer from 'src/components/common/AgFloatButtonContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'
import { createExcelFile } from 'src/services/drawExcelService'
import RejectionCauseList from '../components/RejectionCauseList'

export default {
  name: 'RejectionCauseListContainer',
  components: {
    AgCardContainer,
    AgFloatButtonContainer,
    AgConfirmDialog,
    RejectionCauseList,
  },
  data: () => ({
    rejectionCauseList: [],
    selectedRejectionCauseList: [],
    search: '',
    loadingData: false,
    loadingRemove: false,
    loadingExport: false,
  }),
  computed: {
    removeMessage () {
      const count = this.selectedRejectionCauseList.length
      return `Souhaitez-vous supprimer ${count} cause(s) de rebut`
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'RejectionCauseList' || !this.rejectionCauseList.length) {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      try {
        this.loadingData = true
        this.rejectionCauseList = await Repositories.rejectionCause.getList({ archived: false })
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loadingData = false
      }
    },
    async removeSelected () {
      try {
        this.loadingRemove = true
        const count = this.selectedRejectionCauseList.length
        await Repositories.rejectionCause.delete(
          this.selectedRejectionCauseList.map(select => select._id),
        )
        this.showSuccessNotification(`Vous avez supprimé ${count} cause(s) de rebut`)
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loadingRemove = false
        this.selectedRejectionCauseList = []
        this.fetchData()
      }
    },
    async exportExcel () {
      try {
        this.loadingExport = true
        const exportConfig = {
          columns: [
            { header: 'Nom', key: 'name' },
            { header: 'Type de référence', key: 'partType' },
            { header: 'Id', key: '_id' },
          ],
          view: [{ state: 'frozen', xSplit: 1, ySplit: 1 }],
          sheetName: 'Liste des causes de rebut',
        }
        const data = this.rejectionCauseList.map(item => ({
          _id: item._id,
          name: item.name,
          partType: item.partType.name,
        }))
        await createExcelFile([{ dataToExport: data, config: exportConfig }], 'Liste des causes de rebut')
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loadingExport = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
